var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse, _ellipse2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _ellipse3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 354,
    viewBox: "0 0 447 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.675 346.781H60.7694L58.8774 311.349C57.5014 315.591 53.7173 325.315 49.5893 330.269C44.4293 336.461 36.0013 339.557 25.5092 339.385C13.9852 337.665 9.34115 329.065 5.55713 321.325C1.77312 313.585 1.60112 299.997 3.49313 281.248C4.69713 261.812 15.8772 240.656 29.6372 217.436C44.2296 188.08 78.8699 170.375 86.6972 166.375L86.7415 166.352C92.9335 163.187 102.05 162.052 105.834 161.88C106.12 161.135 106.522 158.646 105.834 154.656C101.018 154.14 90.6975 146.4 84.3335 140.208C77.9694 134.016 76.7654 113.72 76.5934 101.852C76.4558 92.3573 80.4348 68.5409 82.4415 57.8195L86.7415 45.7795L124.926 40.2755L188.222 76.9116L177.042 108.56L164.486 119.74L163.11 133.5L166.378 155.172C171.538 156.491 184.163 159.885 193.382 162.912C202.601 165.939 218.322 178.392 225.03 184.24L278.006 72.6116L308.45 49.0475L350.075 21.1834L375.875 43.8875C378.225 43.5435 383.271 43.0619 384.647 43.8875C386.023 44.7131 386.825 51.4555 387.055 54.7235C387.685 60.0555 388.74 71.2356 387.915 73.2996C387.089 75.3636 382.869 76.6823 380.863 77.0836C381.493 79.6636 382.789 86.9565 382.927 95.4877C383.064 104.019 378.283 117.733 375.875 123.524L373.639 145.54C376.161 151.216 382.411 163.222 387.227 165.836C393.247 169.104 414.403 193.184 417.327 197.484C421.799 198 423.691 202.988 424.551 206.944C427.131 206.772 430.227 209.524 431.431 211.072C432.394 212.311 432.371 216.175 432.239 217.952C431.798 222.482 431.18 233.056 432.239 239.12C434.536 244.083 440.226 266.636 442.783 277.292C443.7 284.574 444.778 301.957 441.751 313.241C437.967 327.345 429.367 331.473 422.659 334.569C417.292 337.045 406.433 335.945 401.675 335.085V346.781Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.262 351.769C195.033 350.806 184.782 345.634 180.31 343.169L243.262 344.545C238.446 348.501 232.942 351.769 224.342 353.317C215.742 354.865 206.798 352.973 200.262 351.769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4921 305.469C65.7227 304.411 74.4189 280.717 79.3399 269.333L93.0012 271.536H102.049L107.544 264.265L118.733 260.78L135.761 261.64L134.206 257.856L126.645 252.868L115.293 251.664L109.445 248.396L107.544 241.569L72.121 234.12L70.3058 239.806L65.413 244.44L56.2038 245.976L47.3901 250.603L41.5049 255.104L56.2038 256.332L66.7803 262.502L72.637 270.928L74.0517 281.011L71.1872 287.18L66.7803 288.943V290.926L63.9158 297.757L58.4072 296.213L53.78 303.045C54.588 304.294 57.2615 306.527 61.4921 305.469Z",
    fill: "#2D2926"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.849 316.266C117.327 313.798 114.668 305.689 114.154 301.944L120.453 305.501L129.569 305.501L132.443 310.317C132.296 313.328 130.372 318.734 123.849 316.266Z",
    fill: "#2D2926"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.115 278.686C75.0592 279.038 73.9223 280.595 73.6108 281.33L78.0495 269.432L84.5906 263.704L103.28 268.551L102.112 278.686L104.915 283.312C96.5049 281.623 79.1708 278.333 77.115 278.686Z",
    fill: "#2D2926"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M307.246 71.5796C307.246 78.6316 302.946 89.8117 301.914 86.3717C301.386 84.6133 296.754 78.861 294.346 76.3956C295.091 76.0516 298.715 74.6068 307.246 71.5796Z",
    fill: "#2D2926"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.342 178.564C222.45 184.756 225.202 184.756 228.814 188.024L231.738 191.464L237.414 184.412L252.894 168.588L276.114 154.656L292.282 148.98L297.27 143.304L298.99 129.544L297.27 108.388L287.122 106.668L279.554 99.7876L277.49 86.1996L281.618 77.5996L292.282 68.8276L308.794 56.2715L313.438 52.1435L326.166 50.4235C332.014 49.5635 345.086 43.9906 350.59 28.5794C362.459 46.2955 372.607 43.8875 378.799 43.3715C384.131 32.8794 366.36 -12.4686 313.438 3.2953C259.602 19.3316 258.226 70.7196 256.85 94.9716C255.94 111.007 235.768 107.872 226.922 135.392C223.826 145.024 230.534 161.708 230.534 165.492C230.534 171.063 226.234 172.372 224.342 178.564Z",
    fill: "#2D2926"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M384.131 164.288C380.003 161.364 357.299 149.84 349.73 147.432V139.52C354.374 139.52 362.287 137.112 367.791 132.124C371.222 129.014 373.295 127.136 376.907 119.224C378.627 135.908 399.267 147.432 384.131 164.288Z",
    fill: "#2D2926"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M362.114 57.6476C362.286 56.7302 363.009 54.6892 364.522 53.8635C366.644 53.4049 371.54 52.4187 374.154 52.1435C377.422 51.7995 377.594 52.1435 379.314 53.8635C381.034 55.5836 380.862 65.3876 380.69 67.1076C380.553 68.4836 378.569 68.9423 377.594 68.9996C374.384 69.2863 367.653 69.6876 366.414 68.9996C365.176 68.3116 363.032 61.1449 362.114 57.6476Z",
    fill: "#2D2926"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M344.054 222.94L330.294 220.188L335.626 258.888L348.699 255.792L344.054 222.94Z",
    fill: "#FABD48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M355.579 311.521L346.463 316.509L348.699 328.377L358.675 332.161L355.579 311.521Z",
    fill: "#FABD48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.378 336.289L369.682 335.085L367.79 305.329L369.682 303.093L372.434 298.621L369.682 293.805L373.294 292.429L375.014 287.269L372.434 282.28L376.39 275.4L371.402 268.692L375.014 265.596L373.294 261.468L364.866 257.34L363.49 224.832H380.346L381.378 336.289Z",
    fill: "#FABD48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M401.675 222.768L419.047 219.328L416.123 265.08L410.963 267.144L409.071 272.132L410.963 276.26L408.039 279.012L407.351 283.312L410.963 288.473L407.351 292.257L408.555 296.901L412.167 300.685L409.415 332.333L396.515 335.429L401.675 222.768Z",
    fill: "#FABD48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M340.27 56.2715L343.538 57.3035L344.742 66.7636L343.538 71.5796L340.27 73.1276L326.166 75.0196L323.586 73.1276L320.834 63.6676L321.522 60.0555L325.478 58.6795L340.27 56.2715Z",
    fill: "#FABD48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.213 148.12C129.219 152.959 117.529 157.034 106.177 154.423M170.85 80.3516C173.487 68.1395 170.678 41.1011 138.341 30.6434C106.005 20.1858 89.9519 33.6821 85.3652 44.7475C78.1412 80.3516 62.6611 140.896 102.909 153.452C103.979 153.847 105.071 154.168 106.177 154.423M106.177 154.423C106.177 154.423 106.349 168.76 107.209 175.296C108.069 181.832 115.5 192.599 134.213 190.26C157.606 187.336 165.001 163.944 165.689 158.956C166.377 153.968 165.173 153.452 163.453 138.144C162.915 133.353 163.465 125.632 164.516 117.16",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.913 86.5439C164.795 82.0031 159.096 91.3026 157.261 96.5199C153.305 100.82 145.049 73.8158 151.241 60.7438C139.889 62.8078 128.193 60.0557 125.269 49.0477C66.4449 71.0638 50.4107 11.399 114.777 6.21955C144.705 3.8113 170.161 16.0234 175.837 42.5117C211.614 53.5197 189.769 107.7 165.001 121.804C164.657 121.116 156.401 115.784 158.809 113.892C162.937 114.58 170.333 112.344 172.913 109.248C175.493 106.152 183.061 92.2199 172.913 86.5439Z",
    fill: "#2D2926"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.253 83.6196C101.017 88.4357 96.8893 93.0797 92.0733 96.5197C86.9132 100.205 87.9452 104.26 90.1812 106.496C92.4173 108.732 96.3733 111.14 103.769 108.904",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124.582 115.612C108.414 129.888 98.1761 118.708 97.4055 121.46C96.4423 124.9 104.286 138.371 116.154 137.112C124.73 136.202 130.086 126.792 129.226 117.16C129.161 114.86 127.309 113.204 124.582 115.612Z",
    fill: "#2D2926"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.109 68.9996C123.205 67.1076 130.567 65.3876 135.245 73.6437",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2653 66.4196C96.2013 64.9862 91.0068 63.2204 86.7412 67.6236",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.177 161.536C48.729 167.728 -2.3111 249.531 2.28879 307.221C4.81201 338.866 25.6809 339.729 31.1849 339.729C36.6889 339.729 56.813 332.849 58.705 305.501M10.8888 300.169C13.4688 294.493 18.9728 288.06 23.7889 285.032",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.769 347.297L58.877 305.673",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4768 296.729C23.8461 284.803 24.0296 258.923 29.8088 250.804C37.0328 240.656 48.7289 230.336 62.833 232.228C69.8506 233.879 71.0317 237.618 70.745 239.28C70.3436 241.516 69.197 245.969 60.4249 245.472C53.1321 245.06 44.4862 252.238 41.5049 255.104",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 268.692C12.0925 266.8 21.2086 266.284 25.1646 266.972",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6128 255.276C46.7222 254.588 62.3169 255.999 67.8209 263.016C74.7009 271.788 78.313 287.613 67.8209 286.753",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5493 270.068C42.7093 269.438 54.3022 268.555 59.3934 272.82C65.7574 278.152 70.5675 290.873 64.2094 295.869C61.8014 297.761 58.7054 296.041 57.8454 294.665",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5171 283.828C40.9891 284 50.7587 285.136 54.0612 288.301C58.1892 292.257 58.3612 299.825 54.7492 302.061C51.6955 303.951 47.0091 302.577 44.4291 299.137",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.313,
    cy: 88.2637,
    rx: 2.58001,
    ry: 5.16002,
    fill: "#2D2926"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.0732,
    cy: 83.7916,
    rx: 2.58001,
    ry: 5.16002,
    fill: "#2D2926"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9648 233.604C51.6528 229.247 54.9897 220.739 62.8329 221.564C70.6761 222.39 72.2929 230.508 72.1209 234.464",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M166.034 155C241.714 171.856 260.462 226.296 260.462 290.881C260.462 375.677 194.758 363.981 150.21 320.293C138.651 317.403 131.633 308.998 129.569 305.157C124.409 305.615 113.677 304.916 112.025 298.449C109.961 290.365 122.689 287.44 134.557 292.945",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M111.681 296.041C109.732 295.467 105.661 293.117 104.973 288.3C104.113 282.28 109.273 270.068 134.729 275.744",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.834 282.796C103.598 280.216 100.467 273.543 105.834 267.488C112.542 259.92 128.194 260.092 136.622 262.156",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M152.961 251.32C148.489 247.594 136.965 240.699 127.505 238.42C103.941 232.744 98.5555 249.117 122.345 251.836C134.385 253.212 134.099 258.946 136.965 262.156",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M117.357 237.216C117.013 234.694 117.426 229.579 121.829 227.928C127.333 225.864 141.781 229.992 155.025 246.332C165.621 259.404 163.797 266.284 168.613 269.552C173.429 272.82 211.854 290.915 226.578 302.061",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184.609 230.508C189.425 243.58 192.693 276.26 192.865 282.452",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M192.693 281.592C204.389 276.662 234.249 271.892 260.118 292.257",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M301.57 85.6837C299.85 82.2437 295.206 75.1367 286.262 75.7077C276.286 76.3445 275.254 91.8758 280.758 100.132C286.262 108.388 294.69 109.076 298.99 107.012",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M296.926 107.872C298.417 115.153 300.17 131.36 298.302 138.832C296.066 147.776 291.405 147.948 291.766 150.184C292.905 157.236 302.43 173.423 323.242 178.048C351.106 184.24 356.094 168.072 355.234 163.084C354.737 160.202 352.482 156.72 349.73 152.592C348.354 148.636 349.558 143.189 349.73 140.208",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M349.73 147.604C364.58 151.789 398.716 167.556 416.467 197.14",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M313.438 74.8476L310.686 57.6475C309.998 54.3795 311.89 51.9297 314.814 51.6275C333.219 49.7254 375.015 44.3174 380.691 43.3715C384.494 42.7377 385.621 45.4928 385.679 46.4675C386.252 50.0795 387.674 59.1267 388.775 66.4196C389.876 73.7124 385.392 76.0516 382.239 76.5676C379.315 76.9116 370.164 77.978 366.587 78.1156C362.115 78.2876 361.083 73.6436 359.019 70.2036C356.955 66.7636 350.591 67.1533 350.591 72.9556C350.591 78.2876 345.603 80.3516 343.711 81.2116C338.723 82.301 327.456 83.9637 322.21 83.9637C315.846 83.9637 314.184 77.7143 313.438 74.8476Z",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M292.454 76.7396L312.234 68.6556",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M282.65 76.5676L311.89 53.1755",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M322.954 72.2024L321.048 62.6716C320.654 60.7047 322.02 58.8198 324.012 58.5813L340.77 56.5751C342.86 56.3249 344.683 57.994 344.617 60.0982L344.317 69.6949C344.265 71.3775 343.002 72.7748 341.334 72.9973L326.782 74.9376C324.984 75.1772 323.309 73.9805 322.954 72.2024Z",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M380.655 65.038L379.532 54.825C379.319 52.8895 377.543 51.5164 375.616 51.797L365.285 53.3015C363.237 53.5998 361.914 55.6272 362.466 57.6226L365.123 67.2309C365.571 68.8481 367.119 69.9067 368.789 69.736L377.586 68.8363C379.486 68.642 380.864 66.9367 380.655 65.038Z",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M285.058 87.4037C289.186 86.3717 294.174 88.9517 296.066 93.7677",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M290.734 96.8637C291.537 95.1437 292.798 91.0845 291.422 88.6077",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M325.306 131.952C366.93 157.236 389.118 115.268 380.862 77.5996",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.899,
    cy: 110.21,
    rx: 8.23902,
    ry: 11.352,
    transform: "rotate(33.2817 352.899 110.21)",
    fill: "#2D2926"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M357.298 79.8356C360.624 80.581 365.795 83.7228 359.878 90.3277",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M291.594 149.324C278.178 152.076 252.722 162.052 232.082 191.292",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M430.743 234.98C442.209 263.59 458.091 324.19 421.971 334.913C414.919 337.006 406.491 335.773 401.331 334.569",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M264.59 273.852C278.35 272.476 302.774 276.088 311.03 280.044",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M280.93 225.176C276.458 236.528 272.33 258.716 271.986 273.68",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M251.001 335.773C260.118 340.589 289.358 345.233 309.998 331.989",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M310.686 331.645C308.278 327.345 303.634 315.408 304.322 302.061C305.182 285.376 317.566 265.768 334.766 259.232C351.966 252.696 372.124 257.505 374.154 262.672C376.046 267.488 371.46 268.864 369.338 269.036",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M338.894 273.852C347.035 270.527 366.255 263.997 373.81 271.788C379.314 277.464 374.67 282.28 367.618 281.592C361.254 280.972 348.216 283.484 341.474 287.612",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M344.914 304.469C351.278 300.341 359.534 295.525 367.962 294.321C376.831 293.054 379.486 283.14 367.962 281.592",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M310.17 331.473C313.897 331.989 322.692 332.229 328.058 329.065C334.766 325.109 345.145 316.623 353.686 312.037C362.974 307.049 368.59 304.269 370.714 301.373C372.606 298.793 370.714 295.009 367.962 294.493",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M421.282 309.113L419.218 328.721C397.546 339.041 369.682 338.181 348.354 328.721L346.29 317.197",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M421.283 309.457C421.283 306.704 420.655 302.904 411.995 300.169C405.459 298.105 404.943 285.721 415.091 289.161C418.703 290.385 423.003 293.805 425.755 296.213",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M429.367 283.828C425.755 281.248 410.97 273.024 407.695 279.873C405.803 283.828 409.587 287.096 413.027 288.472",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M432.119 271.444C428.564 268.807 419.976 263.945 414.059 265.596C406.663 267.66 408.555 275.744 413.027 277.12",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M418.015 265.08C417.155 263.532 415.71 260.402 417.499 258.2C419.735 255.448 429.539 255.62 434.183 260.608C441.869 268.864 451.039 313.413 420.251 319.26",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M401.847 347.813V334.741",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M428.678 257.168L432.29 215.716C421.397 218.354 401.33 224.488 379.83 224.488C359.878 224.488 340.614 222.424 329.606 219.672L335.798 258.372",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M330.466 219.672C330.466 217.895 331.326 214.271 334.766 213.996C333.218 208.32 338.722 200.924 345.602 205.052C346.462 197.312 348.526 195.764 353.514 197.656C352.482 190.948 357.814 186.132 363.662 189.4C367.618 179.252 378.627 181.488 380.347 188.196C384.819 182.176 394.107 183.036 395.655 191.292C399.439 186.992 411.135 191.808 410.447 199.72C416.295 195.936 424.551 197.312 423.863 207.632C429.883 206.6 433.151 211.416 430.743 215.888",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M386.539 207.632C385.163 201.096 394.967 197.656 397.031 205.396C401.503 200.752 409.415 206.428 405.975 212.448",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M344.227 222.424L348.681 256.308M358.675 332.333L355.871 311.005",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M370.026 334.913L368.041 304.469M362.802 224.144L364.866 257.168",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M380.518 224.66L382.066 335.773",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M396.343 335.257L401.503 222.768",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M419.218 219.328L415.354 265.424M409.758 332.161L412.412 300.513",
    stroke: "#2D2926",
    strokeWidth: 3.44001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroVector);
export default __webpack_public_path__ + "static/media/hero-vector.b69cb268501237573525441252471a05.svg";
export { ForwardRef as ReactComponent };